const userAgent = typeof navigator === "undefined" ? "" : navigator.userAgent;

export function isIos() {
  return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
}

export function isAndroid() {
  return /android/i.test(userAgent);
}

export function isAndroidChrome() {
  return isAndroid() && /Chrome/.test(userAgent);
}

export function isTablet() {
  const isIpad = /iPad/.test(userAgent);
  // iPadOS detection: Macintosh UA + touch support
  // Must check for actual touch capability (ontouchend) to exclude desktop Macs with trackpads
  const isIpadOS =
    /Macintosh/.test(userAgent) &&
    navigator.maxTouchPoints > 1 &&
    "ontouchend" in document;
  const isAndroidTablet = isAndroid() && !/mobile/i.test(userAgent);

  return isIpad || isIpadOS || isAndroidTablet;
}
